export default __webpack_public_path__ + "static/media/post1.8f05896d.jpg";